import React from "react";
import { TextField } from "@fluentui/react/lib/TextField";

interface Props {
  label: string;
  hasError?: boolean | "" | undefined;
  errorMessage?: string;
  baseTypeProps?: any;
}

const TextInput = (props: Props) => {
  return (
    <>
      <TextField label={props.label} {...props.baseTypeProps} />
      {props.hasError && props.errorMessage ? (
        <span className="required">{props.errorMessage}</span>
      ) : null}
    </>
  );
};

export default TextInput;
